import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import toLower from 'lodash/toLower';
import trim from 'lodash/trim';

import { ItemTypeIdsSelectGroupedDataType } from '../../ItemTypeIdsSelectField.types';

const NUMERIC_REGEX = /^\d+([.,]\d*)?$/;

export function filterItemTypeGroupedOptions(
  groupedOptions: ItemTypeIdsSelectGroupedDataType[],
  searchValue: string
): ItemTypeIdsSelectGroupedDataType[] {
  const query = toLower(trim(searchValue));

  if (!query) {
    return groupedOptions;
  }

  const isNumeric = NUMERIC_REGEX.test(query);
  const normalizedNumericQuery = query.replace(',', '.');

  const filteredGroups = map(groupedOptions, (group) => {
    const filteredOptions = filter(group.options, (option) => {
      const optionLabel =
        typeof option.label === 'string' ? toLower(option.label) : '';
      const matchesLabel = optionLabel.includes(query);

      if (matchesLabel) {
        return true;
      }

      if (!isNumeric || option.price == null) {
        return false;
      }

      const priceStr = String(option.price);
      const priceFixed = option.price.toFixed(2);
      const priceComma = priceStr.replace('.', ',');
      const priceFixedComma = priceFixed.replace('.', ',');

      return (
        priceStr.includes(normalizedNumericQuery) ||
        priceFixed.includes(normalizedNumericQuery) ||
        priceComma.includes(query) ||
        priceFixedComma.includes(query)
      );
    });

    return {
      ...group,
      options: filteredOptions
    };
  });

  return filter(filteredGroups, (group) => !isEmpty(group.options));
}

export default filterItemTypeGroupedOptions;
